import React from "react";
import { Card, Button } from "antd";
import { connect } from "react-redux";
import { Tag, Popover, Layout, Menu, Row, Col } from "antd";
// import "./Patient.scss";
import utils from "../../utils";
import Prescription from "Pages/Others/Prescription";
import TherapyTab from "Pages/Others/TherapyTab";
import DSMScreening from "Pages/Others/DSMScreening";
import MHE from "Pages/Others/MHE";
import DiagnosisNewSummary from "Pages/Others/DiagnosisNewSummary";
import DiagnosisSummary from "Pages/Others/DiagnosisSummary";
import TreatmentSummary from "Pages/Others/TreatmentSummary";
import SOSSummary from "Pages/Others/SOSSummary";
import UploadDocSummary from "Pages/Others/UploadDocSummary";
import ProtectiveFactorSummary from "Pages/Others/ProtectiveFactorSummary";
import DOTSNewSummary from "Pages/Others/DOTSNewSummary";
import GeriatricSummary from "Pages/Others/GeriatricSummary";
import ConcogSummary from "Pages/Others/ConcogSummary";
import { CONSTANTS } from "utils/constant";
import PSTSummary from "Pages/Others/PSTSummary";
import TheraphyProgressNote from "Pages/Others/TheraphyProgressNote";
import VitalFormHistoryDoctor from "Pages/VitalForm/VitalFormHistoryDoctor";
import icons from "Common/Icons";
import Casesheet from "Pages/Others/Casesheet";

const PatientDetailsAllChild = (props) => {
  const keyArray = ["case_notes", "diagnosis", "prescription", "vitals"];

  function renderContent(key, recorddata) {
    let value = props?.value;
    let modalContent;
    let modalWidth;

    switch (key) {
      //   case "all":
      //     modalContent = (
      //       <PatientDetailsAll data={value} recorddata={recorddata} />
      //     );
      //     modalWidth = "70vw";
      //     break;
      case "prescription":
        modalContent = <Prescription data={value} recorddata={recorddata} />;
        modalWidth = "70vw";
        break;
      case "therapy_intake":
        modalContent = <TherapyTab data={value} recorddata={recorddata} />;
        modalWidth = "850px";
        break;
      case "dsm_screening":
        modalContent = <DSMScreening data={value} recorddata={recorddata} />;
        modalWidth = "850px";
        break;
      case "mhe":
        modalContent = <MHE data={value} recorddata={recorddata} />;
        modalWidth = "850px";
        break;
      case "diagnosis":
        modalContent = (
          <DiagnosisNewSummary data={value} recorddata={recorddata} />
        );
        modalWidth = "850px";
        break;
      case "cf1":
        modalContent = (
          <DiagnosisSummary data={value} recorddata={recorddata} />
        );
        modalWidth = "850px";
        break;
      case "cf2":
        modalContent = (
          <TreatmentSummary data={value} recorddata={recorddata} />
        );
        modalWidth = "850px";
        break;
      case "pst":
        modalContent = <PSTSummary data={value} recorddata={recorddata} />;
        modalWidth = "850px";
        break;
      case "protective_factor":
        modalContent = (
          <ProtectiveFactorSummary data={value} recorddata={recorddata} />
        );
        modalWidth = "850px";
        break;
      case "dots":
        modalContent = <DOTSNewSummary data={value} recorddata={recorddata} />;
        modalWidth = "850px";
        break;
      case "sos":
        modalContent = <SOSSummary data={value} recorddata={recorddata} />;
        modalWidth = "850px";
        break;
      case "cs":
        modalContent = (
          <UploadDocSummary data={value} recorddata={recorddata} />
        );
        modalWidth = "850px";
        break;
      case "confas":
        modalContent = (
          <GeriatricSummary
            title="CONFAS"
            data={value}
            recorddata={recorddata}
          />
        );
        modalWidth = "850px";
        break;
      case "conpsyq":
        modalContent = (
          <GeriatricSummary
            title="CONPSYQ"
            data={value}
            recorddata={recorddata}
          />
        );
        modalWidth = "850px";
        break;
      case "concog":
        modalContent = <ConcogSummary data={value} recorddata={recorddata} />;
        modalWidth = "850px";
        break;
      case "tpn":
        modalContent = (
          <TheraphyProgressNote data={value} recorddata={recorddata} />
        );
        modalWidth = "850px";
        break;
      case "vitals":
        modalContent = (
          <VitalFormHistoryDoctor data={value} recorddata={recorddata} />
        );
        modalWidth = "70vw";
        break;
      case "case_notes":
        modalContent = <Casesheet data={value} recorddata={recorddata} />;
        modalWidth = "70vw";
        break;
    }
    return modalContent;
  }

  return (
    <>
      {props?.records.length > 0 ? (
        <div className="patientDetailsAllChild">
          {props?.records.map((record, index) => (
            <Card
              style={{ marginBottom: "5px" }}
              key={index}
              title={
                <div style={{ fontWeight: "normal" }}>
                  {" "}
                  {utils.FormatDate(record?.date, "DATE_14")},{" "}
                  {utils.FormatDate(record?.date, "TIME_1")}&nbsp;
                </div>
              }
              extra={
                record?.consultation_doctor && (
                  <div style={{ fontSize: "16px" }}>
                    {`${record?.doctor_salutation}. ${record?.consultation_doctor} ${record?.doctor_last_name}`}
                  </div>
                )
              }
            >
              {keyArray.map((key, keyIndex) => (
                <>
                  {record[key]?.length > 0 && (
                    <div style={{ marginBottom: "5px" }} key={keyIndex}>
                      {renderContent(key, record[key])}
                    </div>
                  )}
                </>
              ))}
            </Card>
          ))}
        </div>
      ) : (
        <div style={{display:"flex",alignItems:"center",justifyContent:"center",flexDirection:"column"}}>
          {/* <div className="emptyHistoryTitle"> */}
            <img
              src={icons.empty_folder_icon}
              style={{ width: "24px", height: "24px" }}
              alt=" "
            />
            No data
             {/* to show */}
          {/* </div> */}
        </div>
      )}
    </>
  );
};

export default PatientDetailsAllChild;
